import styled from 'styled-components/macro';
import { Paragraph } from 'components/text';
import { colors as Colors } from 'constants/colors';
import { media } from 'style/media';

export const SubHeroText = styled(Paragraph).attrs(props => ({
  centerTextSmall: true,
  small: true
}))`
  font-size: 0.8333rem;
  line-height: 1.4rem;
  margin: 0 0 1.25rem 0;
  color: ${({ color }) => color || Colors.WHITE};

  ${media.desktop`
    color: ${Colors.WHITE};
    font-size: max(1rem, calc(13px + 0.3vw));
    opacity: 0.6;
  `};
`;

export const SubHeroTextMobile = styled(Paragraph).attrs(props => ({}))`
  font-size: 1rem;
  line-height: 1.4rem;
  margin: 0 0 1.25rem 0;
  color: ${({ color }) => color || Colors.BLACK};
  text-align: left;
`;
